import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import '../styles/general.css';
import '../styles/onboarding.css';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import PersonIcon from '../../src/images/home-landing-page/person-icon.png'
import AccreditationIcon from '../../src/images/home-landing-page/accreditation-icon.png'
import ContactIcon from '../../src/images/home-landing-page/contact-icon.png'
import Footer from '../components/Footer/footer';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import showToast from '../components/ShowToast';
import Loader from '../components/Loader';

const OnboardingStep1 = ({ history }) =>
{
  const [dropdownData, setDropdownData] = useState({
    genders: [],
    ageGroups: [],
    workingStatuses: [],
    livingStatuses: [],
    workingIndustries: []
  });
  const [imagebase64, setImageBase64] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gender: '',
    ageGroup: '',
    workingStatus: '',
    livingStatus: '',
    workingIndustry: '',
    images: null
  });
  const [errors, setErrors] = useState({});
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() =>
  {
    const fetchDropdownData = async () =>
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/homeonboarding/dropdownData`);
        setDropdownData(response.data.model);
      } catch (error)
      {
        console.error('Error fetching dropdown data:', error);
      }
    };

    fetchDropdownData();
  }, []);

  const handleChange = (e) =>
  {
    const { name, value, files } = e.target;
    if (name === 'images')
    {
      if (files[0])
      {
        const reader = new FileReader();
        reader.onloadend = () =>
        {
          setImageBase64(reader.result);
        };
        setPreview(URL.createObjectURL(files[0]));
        reader.readAsDataURL(files[0]);
      }
      setFormData({ ...formData, images: files[0] });
    } else
    {
      setFormData({ ...formData, [name]: value });
      setPreview(null);
    }
  };

  const validateForm = () =>
  {
    const newErrors = {};
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!formData.ageGroup) newErrors.ageGroup = 'Age group is required';
    if (!formData.workingStatus) newErrors.workingStatus = 'Working status is required';
    if (!formData.livingStatus) newErrors.livingStatus = 'Living status is required';
    if (!formData.workingIndustry) newErrors.workingIndustry = 'Industry is required';
    if (!formData.images) newErrors.images = 'Profile image is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) =>
  {

    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try
    {
      const response = await fetch(`${API_BASE_URL}/api/HomeOnboarding/update-profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: jwtDecode(localStorage.getItem('token')).nameid,
          ageGroup: formData.ageGroup,
          workingStatus: formData.workingStatus,
          livingStatus: formData.livingStatus,
          workingIndustry: formData.workingIndustry,
          profilepic: imagebase64
        }),
      });

      if (response.ok)
      {
        showToast('success', 'User details saved successfully!');
        navigate('/home-user-onboarding-02');
      } else
      {
        showToast('error', response.statusText);
        console.error('Error updating profile', response.statusText);
      }
    } catch (error)
    {
      console.error('Error updating profile:', error);
    }
    setLoading(false);
  };

  const handleClear = () =>
  {
    setPreview(null);
    setFormData({ ...formData, images: '' });
    setImageBase64(null);
  }


  return (
    <div>
      <DashboardNavbar prefix={''} />
      {loading ? <Loader /> : null}
      <section className="inner-page-banner text-center">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1>TELL US A BIT ABOUT YOURSELF</h1>
              <p>We will contact you to help in your service</p>
              <div className="banner-stepper">
                <div className="step current">
                  <span className="step-icon">
                    <img src={PersonIcon} />
                  </span>
                  <span className="step-text">Tell us about your locality</span>
                </div>
                <div className="step">
                  <span className="step-icon">
                    <img src={ContactIcon} />
                  </span>
                  <span className="step-text">How can we contact you?</span>
                </div>
                <div className="step">
                  <span className="step-icon">
                    <img src={AccreditationIcon} />
                  </span>
                  <span className="step-text">What accreditation do you have?</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="onboarding-form bottom-hammer-vector">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">

              <form onSubmit={handleSubmit}>
                <div className={`${errors.email ? 'has-error' : ''}`}>
                  <div className="form-main">
                    <div className="form-row">
                      <div className="form-group">
                        <label>Gender</label>

                        <div className="form-control-wrapper">
                          <select name="gender" value={formData.gender} onChange={handleChange} className="form-control">
                            <option value="">Select Gender</option>
                            {dropdownData.genders.map((g) => (
                              <option key={g.id} value={g.gender}>{g.gender}</option>
                            ))}
                          </select>
                          {!formData.gender && (errors.gender && <span className="error">{errors.gender}</span>)}
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Age Group</label>
                        <div className="form-control-wrapper">
                          <select name="ageGroup" value={formData.ageGroup} onChange={handleChange} className="form-control">
                            <option value="">Select Age Group</option>
                            {dropdownData.ageGroups.map((a) => (
                              <option key={a.id} value={a.age}>{a.age}</option>
                            ))}
                          </select>
                          {!formData.ageGroup && (errors.ageGroup && <span className="error">{errors.ageGroup}</span>)}
                        </div></div>
                    </div>
                  </div>

                  <div className="form-main">
                    <div className="form-row">
                      <div className="form-group">
                        <label>I am working</label>
                        <div className="form-control-wrapper">
                          <select name="workingStatus" value={formData.workingStatus} onChange={handleChange} className="form-control">
                            <option value="">Select Working Status</option>
                            {dropdownData.workingStatuses.map((w) => (
                              <option key={w.id} value={w.workingStatus}>{w.workingStatus}</option>
                            ))}
                          </select>
                          {!formData.workingStatus && (errors.workingStatus && <span className="error">{errors.workingStatus}</span>)}
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Living</label>
                        <div className="form-control-wrapper">
                          <select name="livingStatus" value={formData.livingStatus} onChange={handleChange} className="form-control">
                            <option value="">Select Living Status</option>
                            {dropdownData.livingStatuses.map((l) => (
                              <option key={l.id} value={l.livingStatus}>{l.livingStatus}</option>
                            ))}
                          </select>
                          {!formData.livingStatus && (errors.livingStatus && <span className="error">{errors.livingStatus}</span>)}
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="form-main">
                    <div className="form-row">
                      <div className="form-group">
                        <label>Working Industry</label>
                        <div className="form-control-wrapper">
                          <select name="workingIndustry" value={formData.workingIndustry} onChange={handleChange} className="form-control">
                            <option value="">Select Industry</option>
                            {dropdownData.workingIndustries.map((i) => (
                              <option key={i.industryId} value={i.name}>{i.name}</option>
                            ))}
                          </select>
                          {!formData.workingIndustry && (errors.workingIndustry && <span className="error">{errors.workingIndustry}</span>)}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="form-main">
                    <div className="form-row">
                      <div className="form-group">
                        <label>Images</label>
                        <div className="form-control-wrapper custom-upload-file">
                          <div className="drag-drop-button">
                            <input type="file" />
                            <span>Drag and Drop file here</span>
                          </div>

                          <button className="upload-button" type="button">
                            Upload Documentation
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className="form-main">
                    <div className="form-row">
                      <div className="form-group">
                        <label>Images</label>
                        <div className="form-control-wrapper custom-upload-file">
                          <div className="image-preview">     {preview && (
                            <img src={preview} alt="Preview" />)}
                            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="20" height="20"><path d="M19,4h-.508L16.308,1.168A3.023,3.023,0,0,0,13.932,0H10.068A3.023,3.023,0,0,0,7.692,1.168L5.508,4H5A5.006,5.006,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V9A5.006,5.006,0,0,0,19,4ZM9.276,2.39A1.006,1.006,0,0,1,10.068,2h3.864a1.008,1.008,0,0,1,.792.39L15.966,4H8.034ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V9A3,3,0,0,1,5,6H19a3,3,0,0,1,3,3Z" /><path d="M12,8a6,6,0,1,0,6,6A6.006,6.006,0,0,0,12,8Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,18Z" /></svg>
                          </div>
                          <div className="drag-drop-button">
                            <input
                              type="file"
                              name="images"
                              onChange={handleChange}
                              accept="image/*"
                              style={{ display: 'none' }}
                            />
                            <span
                              onClick={() => document.querySelector('input[name="images"]').click()} // Trigger the file input click
                              style={{ cursor: 'pointer' }}>
                              <des title={formData.images ? formData.images.name : ''}> {formData.images ? formData.images.name : 'Click here to Upload'}</des>
                            </span>
                            {preview ? (<button onClick={handleClear} className="clear-button">×</button>) : null}
                          </div>
                        </div>
                        {!formData.images && (errors.images && <span className="error">{errors.images}</span>)}
                      </div>
                    </div>
                  </div>

                  <div className="onboarding-form-button">
                    <button type="submit">Next</button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OnboardingStep1;